import React from "react";
import ResetPassword from "Pages/ResetPassword";


const ResetPasswordtheme = () => {
  return (
    <React.Fragment>
       <ResetPassword/>
    </React.Fragment>
  );
};

export default ResetPasswordtheme;
